<app-admin-header [header]="'Orders' | translator" [links]="[]" [breadcrumbs]="breadcrumbs" [stats]="[]">
</app-admin-header>

<div class="container-fluid p-4">
    <!-- Enhanced Filter Section -->
    <div class="filter-section mb-4">
        <div class="row">
            <!-- Search by Order ID -->
            <div class="col-md-3">
                <div class="p-inputgroup v4-addon">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-hashtag"></i>
                    </span>
                    <input type="text" 
                           pInputText 
                           placeholder="{{ 'Search by Order ID...' | translator }}"
                           [(ngModel)]="searchById"
                           (input)="onSearch()"
                           class="w-100" />
                </div>
            </div>
            
            <!-- Search by Email -->
            <div class="col-md-3">
                <div class="p-inputgroup v4-addon">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-envelope"></i>
                    </span>
                    <input type="text" 
                           pInputText 
                           placeholder="{{ 'Search by Customer Email...' | translator }}"
                           [(ngModel)]="searchByEmail"
                           (input)="onSearch()"
                           class="w-100" />
                </div>
            </div>
            
            <!-- General Search -->
            <div class="col-md-3">
                <div class="p-inputgroup v4-addon">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-search"></i>
                    </span>
                    <input type="text" 
                           pInputText 
                           placeholder="{{ 'General Search...' | translator }}"
                           [(ngModel)]="searchText"
                           (input)="onSearch()"
                           class="w-100" />
                </div>
            </div>
            
            <!-- Status Filter -->
            <div class="col-md-3">
                <p-dropdown 
                    [options]="statusOptions" 
                    [(ngModel)]="selectedStatus"
                    optionLabel="name" 
                    optionValue="value"
                    placeholder="{{ 'Filter by Status' | translator }}"
                    (onChange)="onStatusFilterChange()"
                    class="w-100 ppp-dropdown">
                </p-dropdown>
            </div>
        </div>
        
        <!-- Filter Actions Row -->
        <div class="row mt-3">
            <div class="col-md-6">
                <div class="d-flex align-items-center">
                    <span class="text-muted me-3">
                        <i class="pi pi-info-circle me-1"></i>
                        {{ "Total Orders" | translator }}: <strong>{{ totalOrders }}</strong>
                    </span>
                    <span class="text-muted me-3" *ngIf="ordersData.length > 0">
                        {{ "Showing" | translator }}: <strong>{{ ordersData.length }}</strong> {{ "orders" | translator }}
                    </span>
                </div>
            </div>
            <div class="col-md-6">
                <div class="d-flex justify-content-end">
                    <button class="btn btn-outline-secondary btn-sm m-l-2" 
                            (click)="clearFilters()"
                            title="Clear all filters">
                        <i class="pi pi-times me-1"></i>
                        {{ "Clear Filters" | translator }}
                    </button>
                    <button class="btn btn-primary btn-sm" 
                            (click)="loadOrders()"
                            title="Refresh orders">
                        <i class="pi pi-refresh me-1"></i>
                        {{ "Refresh" | translator }}
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Orders Grid -->
    <div class="orders-grid" *ngIf="!spinner && ordersData.length > 0">
        <div class="order-card" *ngFor="let order of ordersData; let i = index" [class.expanded]="order.isExpanded">
            <div class="order-card-main-content">
            <!-- Card Header with Entity Name and Status -->
            <div class="order-card-header">
                <div class="order-card-number-section">
                    <p class="entity-name" *ngIf="order.customer.organization">
                        <strong>{{ order.customer.organization }}</strong>
                    </p>
                </div>
                <div class="order-status-badge" [ngClass]="'status-' + order.orderStatus.toLowerCase()">
                    {{ getStatusLabel(order.orderStatus) | translator }}
                </div>
            </div>

            <!-- Order Header -->
            <div class="order-header">
                <div class="d-flex justify-content-between align-items-start">
                    <div>
                        <h3 class="order-id">{{ order.orderId }}</h3>
                        <p class="product-name-below-id">
                            <strong>{{ order.productService.productName }}</strong>
                        </p>
                        <p class="order-date">
                            <i class="pi pi-calendar me-1"></i>
                            {{ formatDate(order.createdAt) }}
                        </p>
                    </div>
                </div>
            </div>

            <div class="order-card-preview">
                <hr class="order-divider">

                <!-- Customer Information -->
                <div class="order-customer">
                    <h4 class="section-heading">
                        <i class="pi pi-user me-2"></i>
                        {{ "Customer Information" | translator }}
                    </h4>
                    <div class="customer-details">
                        <p class="customer-name">
                            <strong>{{ order.customer.name }}</strong>
                        </p>
                        <p class="customer-email">
                            <i class="pi pi-envelope me-1"></i>
                            {{ order.customer.email }}
                            <button class="copy-email-btn" 
                                    (click)="copyEmailToClipboard(order.customer.email); $event.stopPropagation()"
                                    title="{{ 'Copy Email' | translator }}">
                                <i class="pi pi-copy"></i>
                            </button>
                        </p>
                        <p class="customer-phone" *ngIf="order.customer.phone">
                            <i class="pi pi-phone me-1"></i>
                            {{ order.customer.phone }}
                        </p>
                        <p class="customer-org" *ngIf="order.customer.organization">
                            <i class="pi pi-building me-1"></i>
                            {{ order.customer.organization }}
                        </p>
                    </div>
                </div>

                <!-- Order Notes -->
                <div class="order-notes" *ngIf="order.orderNotes">
                    <h4 class="section-heading">
                        <i class="pi pi-file-text me-2"></i>
                        {{ "Order Notes" | translator }}
                    </h4>
                    <div class="notes-content">
                        <p>
                            {{ truncateText(order.orderNotes, 80) }}
                        </p>
                    </div>
                </div>

                <!-- Order History -->
                <div class="order-history" *ngIf="(order.orderHistory && order.orderHistory.length > 0) || getAttachmentCount(order) > 0">
                    <h4 class="section-heading">
                        <i class="pi pi-history me-2"></i>
                        {{ "Order History" | translator }}
                    </h4>
                    <div class="history-timeline">
                        <div class="history-more" *ngIf="getTotalHistoryCount(order) > 0 || getAttachmentCount(order) > 0">
                            <button class="see-more-btn" (click)="viewOrderDetails(order); $event.stopPropagation()">
                                {{ "View Full History" | translator }} ({{ getTotalHistoryCount(order) + getAttachmentCount(order) }} {{ "more" | translator }})
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            </div>

            <div class="order-card-bottom">
                <div class="order-actions">
                    <div class="action-buttons-grid">
                        <button class="action-btn primary-btn" (click)="viewOrderDetails(order); $event.stopPropagation()">
                            <i class="pi pi-eye me-2"></i>
                            {{ "View Details" | translator }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- No Data Message -->
    <div class="d-flex justify-content-center" *ngIf="!spinner && ordersData.length === 0">
        <app-no-data></app-no-data>
    </div>

    <!-- Loading Spinner -->
    <div class="d-flex justify-content-center" *ngIf="spinner">
        <p-progressSpinner [hidden]="!spinner" styleClass="w-4rem h-4rem pb-4" strokeWidth="8"
            fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
    </div>

    <!-- Pagination -->
    <div class="pagination-container mt-4" *ngIf="totalOrders > rows">
        <p-paginator (onPageChange)="onPageChange($event)" [first]="first"
            [rows]="rows" [totalRecords]="totalOrders" [rowsPerPageOptions]="[10, 20, 30]">
        </p-paginator>
    </div>
</div>

<app-footer></app-footer>

<!-- Status Update Dialog -->
<p-dialog 
    [(visible)]="showStatusUpdateDialog" 
    [modal]="true" 
    [closable]="true" 
    [draggable]="false" 
    [resizable]="false"
    [style]="{width: '500px'}"
    [header]="'Update Order Status' | translator"
    (onHide)="closeStatusUpdateDialog()">
    
    <div class="status-update-content" *ngIf="selectedOrder">
        <!-- Order Info -->
        <div class="order-info mb-4">
            <h5>{{ "Order" | translator }}: {{ selectedOrder.orderId }}</h5>
            <p class="text-muted">{{ "Customer" | translator }}: {{ selectedOrder.customer.name }}</p>
            <p class="text-muted">{{ "Product" | translator }}: {{ selectedOrder.productService.productName }}</p>
        </div>

        <!-- Status Selection -->
        <div class="form-group mb-3">
            <label for="statusSelect" class="form-label">{{ "New Status" | translator }}</label>
            <p-dropdown 
                id="statusSelect"
                [options]="[
                    { label: this.translate('Pending in orders'), value: 'PENDING' },
                    { label: this.translate('Accepted'), value: 'ACCEPTED' },
                    { label: this.translate('Update Required'), value: 'UPDATE' },
                    { label: this.translate('Rejected'), value: 'REJECTED' },
                    { label: this.translate('Canceled'), value: 'CANCELED' }
                ]"
                [(ngModel)]="newStatus"
                optionLabel="label" 
                optionValue="value"
                placeholder="{{ 'Select Status' | translator }}"
                class="w-100">
            </p-dropdown>
        </div>

        <!-- Notes -->
        <div class="form-group mb-3">
            <label for="statusNotes" class="form-label">{{ "Notes (Optional)" | translator }}</label>
            <textarea 
                id="statusNotes"
                pInputTextarea 
                [(ngModel)]="statusUpdateNotes"
                placeholder="{{ 'Add any notes about this status change...' | translator }}"
                rows="3"
                class="w-100">
            </textarea>
        </div>

        <!-- Action Buttons -->
        <div class="d-flex justify-content-end gap-2">
            <button type="button" 
                    class="btn btn-secondary" 
                    (click)="closeStatusUpdateDialog()">
                    {{ "Cancel" | translator }}
            </button>
            <button type="button" 
                    class="btn btn-primary" 
                    (click)="updateOrderStatus()">
                Update Status
            </button>
        </div>
    </div>
</p-dialog>

<p-confirmDialog></p-confirmDialog>

<p-toast></p-toast>
